module.exports = __webpack_public_path__ + "static/media/HTML.35970109.svg";